export default {
  allowAlignment: true,
  anchorEditor: false,
  anchorPreview: false,
  textFormatter: false,
  allowAttribute: true,
  allowBold: true,
  allowItalic: true,
  allowAnchor: true,
  allowHeading: true,
  allowSubheading: true,
  allowOrderedList: true,
  allowUnorderedList: true,
  allowCode: true,
  allowVideo: false,
  allowSocial: false,
  allowHtml: true,
  autoFocusTopLeft: false,
  urlReplacement: false,
  markdownLinks: false,
  readOnly: true
};